import {Button} from "@mui/material";
import React from "react";
import appointmentApi from "src/api/project/appointment";
import {useConfirm} from "material-ui-confirm";

const CancelAppointmentButton = ({ appointment, setCancelError, onSuccess, buttonVariant = 'outlined' }) => {
  const confirm = useConfirm();

  const cancelAppointment = (appointment) => {
    confirm({
      title: 'Afspraak annuleren',
      description: 'Weet je zeker dat je je afspraak wilt annuleren?',
      confirmationText: 'Annuleren bevestigen',
      cancellationText: 'Afbreken',
    })
      .then(() => {
        setCancelError(false);
        appointmentApi.cancelAppointment(appointment.id)
          .then(() => {
            if (onSuccess) {
              onSuccess();
            }
            confirm({
              title: 'Afspraak geannuleerd',
              description: 'Jouw afspraak is succesvol geannuleerd. Je kunt nu ook een nieuwe afspraak maken voor dit project.',
              confirmationText: 'Sluiten',
              hideCancelButton: true,
            })
          })
          .catch(() => {
            setCancelError(true);
          })
      })
  }

  return (
    <Button variant={buttonVariant} color="primary" size="small" onClick={() => cancelAppointment(appointment)}>Annuleren</Button>
  );
}

export default CancelAppointmentButton;